import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { ButtonComp } from 'atoms/Buttons';
import React from 'react';
import Accordian from 'atoms/Accordian/Accordian';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

const FaqComponent = props => {
  const { faqAndContactData = {}, isMobile } = props;
  const { faqData = {}, contactData = {} } = faqAndContactData;
  const { CART_FAQ_HEADER } = CART_PAGE_CONSTANTS;
  const ContactClickHandler = () => {
    props.history.push({
      pathname: '/contactus',
    });
  };
  const { Call_Icon, MailIcon } = IMAGE_PATH;
  const ViewAllFaqHandler = () => {
    props.history.push({
      pathname: '/faq',
    });
  };

  return (
    <div className='cart-faq-container' data-testid='cart-faq-test'>
      {faqData?.faqButtonText && (
        <div className='cart-faq-header-container'>
          <h2 className='cart-faq-header'>{translateWithI18Next(CART_FAQ_HEADER)}</h2>
          <div className='cart-faq-list'>
            {faqData.faqContent &&
              faqData.faqContent.map((item, index) => {
                return index < 3 ? (
                  <div key={index} className='cart-accordian-container'>
                    <Accordian header={item.question}>
                      <div className='cart-accordian-content'>{item.answer}</div>
                    </Accordian>
                  </div>
                ) : null;
              })}
          </div>
          <ButtonComp
            className='button  whiteButton blackBorder faq-view-all'
            onClickHandler={ViewAllFaqHandler}
            data-testid='view-all-btn'
            aria-label={translateWithI18Next('viewallFaqs')}
          >
            {faqData.faqButtonText}
          </ButtonComp>
        </div>
      )}
      <div className='cart-faq-contact-header-container'>
        <h2 className='cart-faq-contact-header'>{contactData.headline}</h2>
        <div className='cart-faq-contact-content'>
          <a href={'tel: 080-4275-4444'} className='anchorTags' tabIndex='-1'>
            <ButtonComp
              className='button  whiteButton blackBorder call-contact-button'
              aria-label={translateWithI18Next('callUs')}
            >
              <img src={Call_Icon} alt=' ' />
              <span className='contact-text'>{isMobile ? 'Call Us' : contactData.callButtonText}</span>
            </ButtonComp>
          </a>
          <ButtonComp
            className='button  whiteButton blackBorder mail-contact-button'
            onClickHandler={ContactClickHandler}
            data-testid='contact-us-button'
            aria-label={translateWithI18Next('contactUs')}
          >
            <img src={MailIcon} alt=' ' />
            <span className='contact-text'>{contactData.mailButtonText}</span>
          </ButtonComp>
        </div>
      </div>
    </div>
  );
};

export default FaqComponent;
